var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemAvatar = void 0;
var ListItemAvatar_1 = __importDefault(require("./ListItemAvatar"));
exports.ListItemAvatar = ListItemAvatar_1.default;
exports.default = ListItemAvatar_1.default;
//# sourceMappingURL=index.js.map